(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popups"]) return;
  try {
    
  if (window.Shopify?.designMode && !document.documentElement.hasAttribute('data-fitz-popup-editor-bound')) {
    document.documentElement.setAttribute('data-fitz-popup-editor-bound', 'true');
    let selectedPopup = null;

    const popupElements = () => Array.from(document.querySelectorAll('[data-fitz-popup-section] [data-fitz-popup-block]'));

    const hidePopupPreviews = () => {
      popupElements().forEach((popup) => popup.setAttribute('aria-hidden', 'true'));
    };

    const findPopupPreview = (sectionId, blockId) => popupElements().find((popup) => {
      const section = popup.closest('[data-fitz-popup-section]');
      return section.dataset.fitzPopupSection === String(sectionId) && popup.dataset.fitzPopupBlock === String(blockId);
    });

    const showPopupPreview = (popup) => {
      hidePopupPreviews();
      popup.setAttribute('aria-hidden', 'false');
    };

    document.addEventListener('shopify:block:select', (event) => {
      const popup = findPopupPreview(event.detail?.sectionId, event.detail?.blockId);
      if (!popup) {
        selectedPopup = null;
        hidePopupPreviews();
        return;
      }
      selectedPopup = { sectionId: String(event.detail.sectionId), blockId: String(event.detail.blockId) };
      showPopupPreview(popup);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      if (!selectedPopup || String(event.detail?.sectionId) !== selectedPopup.sectionId || String(event.detail?.blockId) !== selectedPopup.blockId) return;
      if (!event.target.isConnected) return;
      selectedPopup = null;
      hidePopupPreviews();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (selectedPopup?.sectionId === String(event.detail?.sectionId)) hidePopupPreviews();
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (selectedPopup?.sectionId !== String(event.detail?.sectionId)) return;
      requestAnimationFrame(() => {
        if (!selectedPopup) return;
        const popup = findPopupPreview(selectedPopup.sectionId, selectedPopup.blockId);
        if (popup) showPopupPreview(popup);
      });
    });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const popup = event.target.closest('[data-fitz-popup-block]');
      if (!popup || !popup.closest('[data-fitz-popup-section]')) return;
      if (event.target === popup || event.target.closest('[data-action="close-popup"]')) {
        popup.setAttribute('aria-hidden', 'true');
      }
    });

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') hidePopupPreviews();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
